import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NavigationExtras, Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { Checklist } from 'src/app/models/checklist.model';
import { Party } from 'src/app/models/party.model';
import { CommonService } from 'src/app/services/common.service';
import { constants } from 'src/app/utils/constants';

@Component({
  selector: 'app-parties',
  templateUrl: './parties.component.html',
  styleUrls: ['./parties.component.scss'],
  standalone: false
})
export class PartiesComponent  implements OnInit {

  public accessibleMode: string = '';
  public partyTypeList: any = [];
  public partiesList: any = [];
  public itemId: string = '';
  public partiesForm: FormGroup;
  public hideHomeAwayFields: boolean = true;
  @ViewChild('content') private content: any;


  constructor(
    private formBuilder: FormBuilder,
    public navController: NavController,
    private router: Router,
    private commonService: CommonService,
  ) {
    this.hideHomeAwayFields = true;
    this.partiesForm = this.formBuilder.group({
      homeTeamParty: this.formBuilder.group({
        hmTeamType: new FormControl(constants.TEAM.HOME_TEAM),
        hmTeamName: new FormControl('', [Validators.required, Validators.pattern(constants.REGEX.ALPHA_NUMERIC)]),
        hmTeamPosition: new FormControl('', [Validators.pattern(constants.REGEX.ALPHA_NUMERIC)]),
        hmTeamEmail: new FormControl('', [Validators.email]),
        hmTeamComment: new FormControl('', [Validators.pattern(constants.REGEX.ALPHA_NUMERIC)])
      }),
      homeTMRepParty: this.formBuilder.group({
        hmTmRepType: new FormControl(constants.TEAM.HOME_TEAM_REPRESENTATIVE),
        hmTmRepName: new FormControl('', [Validators.required, Validators.pattern(constants.REGEX.ALPHA_NUMERIC)]),
        hmTmRepPosition: new FormControl('', [Validators.required, Validators.pattern(constants.REGEX.ALPHA_NUMERIC)]),
        hmTmRepEmail: new FormControl('', [Validators.required, Validators.email]),
        hmTmRepComment: new FormControl('', [Validators.pattern(constants.REGEX.ALPHA_NUMERIC)]),
      }),
      awayTeamParty: this.formBuilder.group({
        awayTeamType: new FormControl({ value: constants.TEAM.AWAY_TEAM, disabled: true }),
        awayTeamName: new FormControl('', [Validators.required, Validators.pattern(constants.REGEX.ALPHA_NUMERIC)]),
        awayTeamPosition: new FormControl('', [Validators.pattern(constants.REGEX.ALPHA_NUMERIC)]),
        awayTeamEmail: new FormControl('', [Validators.email]),
        awayTeamComment: new FormControl('', [Validators.pattern(constants.REGEX.ALPHA_NUMERIC)])
      }),
      awayTMrepParty: this.formBuilder.group({
        awayTMrepType: new FormControl({ value: constants.TEAM.AWAY_TEAM_REPRESENTATIVE, disabled: true }),
        awayTMrepName: new FormControl('', [Validators.required, Validators.pattern(constants.REGEX.ALPHA_NUMERIC)]),
        awayTMrepPosition: new FormControl('', [Validators.required, Validators.pattern(constants.REGEX.ALPHA_NUMERIC)]),
        awayTMrepEmail: new FormControl('', [Validators.required, Validators.email]),
        awayTMrepComment: new FormControl('', [Validators.pattern(constants.REGEX.ALPHA_NUMERIC)])
      }),
      parties: this.formBuilder.array([])
    });
  }

  async ngOnInit() {
    this.hideHomeAwayFields = constants.TRUE;

    if (this.router?.getCurrentNavigation()?.extras.state?.['queryParams'].itemId) {
      this.accessibleMode = this.router?.getCurrentNavigation()?.extras.state?.['queryParams'].accessibleMode;
      this.itemId = this.router?.getCurrentNavigation()?.extras.state?.['queryParams'].itemId;
      var checkItem: Checklist = await this.commonService.getItem(this.itemId);
      if ((this.accessibleMode === constants.VIEW || this.accessibleMode === constants.EDIT) 
        && (JSON.stringify(checkItem.parties) !== '{}' || JSON.stringify(checkItem.parties) !== '[]')
        && !this.commonService.checkIfArrayEmpty(JSON.parse(JSON.stringify(checkItem.parties)))) {
        this.commonService.setCurrentMode(this.accessibleMode, checkItem);
        this.getPartyList();
        this.getEditInfo(checkItem);
      } else {
        this.getPartyList();
      }
    } else {
      this.navController.navigateForward(constants.PAGE.CHECKLIST);
    }
    this.commonService.pushCurrentTabPosition(3);
  }

  get parties(): FormArray {
    return this.partiesForm.get('parties') as FormArray;
  }

  public addNewParty() {
    const partyGroup = this.formBuilder.group({
      type: new FormControl('', Validators.required),
      name: new FormControl('', [Validators.required, Validators.pattern(constants.REGEX.ALPHA_NUMERIC)]),
      position: new FormControl('', [Validators.pattern(constants.REGEX.ALPHA_NUMERIC)]),
      email: new FormControl('', [Validators.required, Validators.email]),
      comment: new FormControl('', [Validators.pattern(constants.REGEX.ALPHA_NUMERIC)])
    });

    if (!this.parties || this.parties.length < 3) {
      this.parties.push(partyGroup);
      this.content?.scrollToBottom(600);
    }
  }

  public removeParty(partyIndex: number) {
    this.parties.removeAt(partyIndex);
  }

  public getPartyList() {
    var parties = this.commonService.getSelectedItem('PARTY_TYPE');
    for (let index = 0; index < parties.length; index++) {
      const partyType = parties[index];
      if (
        !(partyType === constants.TEAM.HOME_TEAM 
        || partyType === constants.TEAM.HOME_TEAM_REPRESENTATIVE 
        || partyType === constants.TEAM.AWAY_TEAM 
        || partyType === constants.TEAM.AWAY_TEAM_REPRESENTATIVE)
      ) {
        this.partyTypeList.push(partyType);
      }
    }
  }

  public getEditInfo(checkItem: Checklist) {
    if (JSON.stringify(checkItem.parties) !== '{}') {
      var partyInfo = checkItem.parties;
      var homeTeamParty;
      var homeTMRepParty;
      var awayTeamParty;
      var awayTMrepParty;
      for (let index = 0; index < partyInfo.length; index++) {
        const element = partyInfo[index];
        if (element.type === constants.TEAM.HOME_TEAM) {
          homeTeamParty = this.formBuilder.group({
            hmTeamType: new FormControl({ value: constants.TEAM.HOME_TEAM, disabled: true }),
            hmTeamName: new FormControl(element[Object.keys(element)[1]] ? element[Object.keys(element)[1]] : '', [Validators.required, Validators.pattern(constants.REGEX.ALPHA_NUMERIC)]),
            hmTeamPosition: new FormControl(element[Object.keys(element)[2]] ? element[Object.keys(element)[2]] : '', [Validators.pattern(constants.REGEX.ALPHA_NUMERIC)]),
            hmTeamEmail: new FormControl(element[Object.keys(element)[3]] ? element[Object.keys(element)[3]] : '', Validators.email),
            hmTeamComment: new FormControl(element[Object.keys(element)[4]] ? element[Object.keys(element)[4]] : '', [Validators.pattern(constants.REGEX.ALPHA_NUMERIC)])
          });
        }
        else if (element.type === constants.TEAM.HOME_TEAM_REPRESENTATIVE) {
          homeTMRepParty = this.formBuilder.group({
            hmTmRepType: new FormControl({ value: constants.TEAM.HOME_TEAM_REPRESENTATIVE, disabled: true }),
            hmTmRepName: new FormControl(element[Object.keys(element)[1]] ? element[Object.keys(element)[1]] : '', [Validators.required, Validators.pattern(constants.REGEX.ALPHA_NUMERIC)]),
            hmTmRepPosition: new FormControl(element[Object.keys(element)[2]] ? element[Object.keys(element)[2]] : '', [Validators.required, Validators.pattern(constants.REGEX.ALPHA_NUMERIC)]),
            hmTmRepEmail: new FormControl(element[Object.keys(element)[3]] ? element[Object.keys(element)[3]] : '', [Validators.required, Validators.email]),
            hmTmRepComment: new FormControl(element[Object.keys(element)[4]] ? element[Object.keys(element)[4]] : '', [Validators.pattern(constants.REGEX.ALPHA_NUMERIC)])
          });
        }
        else if (element.type === constants.TEAM.AWAY_TEAM) {
          awayTeamParty = this.formBuilder.group({
            awayTeamType: new FormControl({ value: constants.TEAM.AWAY_TEAM, disabled: true }),
            awayTeamName: new FormControl(element[Object.keys(element)[1]] ? element[Object.keys(element)[1]] : '', [Validators.required, Validators.pattern(constants.REGEX.ALPHA_NUMERIC)]),
            awayTeamPosition: new FormControl(element[Object.keys(element)[2]] ? element[Object.keys(element)[2]] : '', [Validators.pattern(constants.REGEX.ALPHA_NUMERIC)]),
            awayTeamEmail: new FormControl(element[Object.keys(element)[3]] ? element[Object.keys(element)[3]] : '', Validators.email),
            awayTeamComment: new FormControl(element[Object.keys(element)[4]] ? element[Object.keys(element)[4]] : '', [Validators.pattern(constants.REGEX.ALPHA_NUMERIC)])
          });
        }
        else if (element.type === constants.TEAM.AWAY_TEAM_REPRESENTATIVE) {
          awayTMrepParty = this.formBuilder.group({
            awayTMrepType: new FormControl({ value: constants.TEAM.AWAY_TEAM_REPRESENTATIVE, disabled: true }),
            awayTMrepName: new FormControl(element[Object.keys(element)[1]] ? element[Object.keys(element)[1]] : '', Validators.required),
            awayTMrepPosition: new FormControl(element[Object.keys(element)[2]] ? element[Object.keys(element)[2]] : '', Validators.required),
            awayTMrepEmail: new FormControl(element[Object.keys(element)[3]] ? element[Object.keys(element)[3]] : '', Validators.required),
            awayTMrepComment: new FormControl(element[Object.keys(element)[4]] ? element[Object.keys(element)[4]] : '')
          });
        }
        else {
          var party: any = this.formBuilder.group({
            type: new FormControl(element[Object.keys(element)[0]] ? element[Object.keys(element)[0]] : ''),
            name: new FormControl(element[Object.keys(element)[1]] ? element[Object.keys(element)[1]] : '', [Validators.required, Validators.pattern(constants.REGEX.ALPHA_NUMERIC)]),
            position: new FormControl(element[Object.keys(element)[2]] ? element[Object.keys(element)[2]] : '', [Validators.pattern(constants.REGEX.ALPHA_NUMERIC)]),
            email: new FormControl(element[Object.keys(element)[3]] ? element[Object.keys(element)[3]] : '', Validators.email),
            comment: new FormControl(element[Object.keys(element)[4]] ? element[Object.keys(element)[4]] : '', [Validators.pattern(constants.REGEX.ALPHA_NUMERIC)]),
          });
          this.parties.push(party);
        }
      }
      this.partiesForm = this.formBuilder.group({
        homeTeamParty: homeTeamParty,
        homeTMRepParty: homeTMRepParty,
        awayTeamParty: awayTeamParty,
        awayTMrepParty: awayTMrepParty,
        parties: this.parties
      });
    }
  }

  public isValidEmailAddress(emailAddress: string): boolean {
    const emailIdregex = new RegExp('[a-z0-9]+@[a-z]+\.[a-z]{2,3}');
    console.log('EmailId is valid :', emailIdregex.test(emailAddress));
    return emailIdregex.test(emailAddress);
  }

  
  public async nextPage() {
    var partyInformations: any[] = [];
    this.commonService.pushCurrentTabPosition(4);
    if (this.partiesForm.valid) {
      let navigationExtras: NavigationExtras = {
        state: {
          queryParams: {
            accessibleMode: this.accessibleMode,
            itemId: this.itemId
          }
        }
      };
      var homeTeamParty: any = {
        'type': this.partiesForm.get('homeTeamParty.hmTeamType')?.value,
        'home team.name': this.partiesForm.get('homeTeamParty.hmTeamName')?.value,
        'home team.position': this.partiesForm.get('homeTeamParty.hmTeamPosition')?.value,
        'home team.email': this.partiesForm.get('homeTeamParty.hmTeamEmail')?.value,
        'home team.comment': this.partiesForm.get('homeTeamParty.hmTeamComment')?.value
      }
      partyInformations.push(homeTeamParty);

      var homeTMRepParty: any = {
        'type': this.partiesForm.get('homeTMRepParty.hmTmRepType')?.value,
        'home team representative.name': this.partiesForm.get('homeTMRepParty.hmTmRepName')?.value,
        'home team representative.position': this.partiesForm.get('homeTMRepParty.hmTmRepPosition')?.value,
        'home team representative.email': this.partiesForm.get('homeTMRepParty.hmTmRepEmail')?.value,
        'home team representative.comment': this.partiesForm.get('homeTMRepParty.hmTmRepComment')?.value
      }
      partyInformations.push(homeTMRepParty);

      var awayTeamParty: any = {
        'type': this.partiesForm.get('awayTeamParty.awayTeamType')?.value,
        'away team.name': this.partiesForm.get('awayTeamParty.awayTeamName')?.value,
        'away team.position': this.partiesForm.get('awayTeamParty.awayTeamPosition')?.value,
        'away team.email': this.partiesForm.get('awayTeamParty.awayTeamEmail')?.value,
        'away team.comment': this.partiesForm.get('awayTeamParty.awayTeamComment')?.value
      }
      partyInformations.push(awayTeamParty);

      var awayTMrepParty: any = {
        'type': this.partiesForm.get('awayTMrepParty.awayTMrepType')?.value,
        'away team representative.name': this.partiesForm.get('awayTMrepParty.awayTMrepName')?.value,
        'away team representative.position': this.partiesForm.get('awayTMrepParty.awayTMrepPosition')?.value,
        'away team representative.email': this.partiesForm.get('awayTMrepParty.awayTMrepEmail')?.value,
        'away team representative.comment': this.partiesForm.get('awayTMrepParty.awayTMrepComment')?.value
      };
      partyInformations.push(awayTMrepParty);

      var allParties = this.partiesForm.get('parties')?.value;
      allParties.forEach((party: Party) => {
        const typeStr = party.type?.toLowerCase();
        var partyInfo: any = {
          ['type']: party.type,
          [typeStr + '.name']: party.name,
          [typeStr + '.position']: party.position,
          [typeStr + '.email']: party.email,
          [typeStr + '.comment']: party.comment
        }
        partyInformations.push(partyInfo);
      });
      if (this.accessibleMode === constants.VIEW) {
        this.navController.navigateForward(constants.PAGE.RISK, navigationExtras);
      }
      else if (this.accessibleMode === constants.NEW || this.accessibleMode === constants.EDIT) {
        var returnItemId: string = await this.commonService.insertChecklistItem(this.itemId, constants.PARTIES, partyInformations);
        if (this.itemId === returnItemId) {
          var declarationInfo = {
            submissionDateTime: this.commonService.getCurrentDate(),
            homeTeamRepresentativeName: this.partiesForm.get('homeTMRepParty.hmTmRepName')?.value,
            homeTeamRepresentativePosition: this.partiesForm.get('homeTMRepParty.hmTmRepPosition')?.value,
            awayTeamRepresentativeName: this.partiesForm.get('awayTMrepParty.awayTMrepName')?.value,
            awayTeamRepresentativePosition: this.partiesForm.get('awayTMrepParty.awayTMrepPosition')?.value,
            email: this.partiesForm.get('homeTMRepParty.hmTmRepEmail')?.value + ',' + this.partiesForm.get('awayTMrepParty.awayTMrepEmail')?.value,
            weAreAuthorisedRepresentatives: false,
            weDeclareThatAfterReasonableInquiry: false,
            inspectionMatchDayChecklistCompleted: false
          };
          this.commonService.pushSourceOfData(declarationInfo);
          this.navController.navigateForward(constants.PAGE.RISK, navigationExtras);
        }
      } else {
        this.navController.navigateBack(constants.PAGE.CHECKLIST, { replaceUrl: true });
      }
    }
    else {
      this.partiesForm.markAllAsTouched();
    }
  }

  backToPage() {
    this.commonService.pushCurrentTabPosition(2);
    let navigationExtras: NavigationExtras = {
      state: {
        queryParams: {
          accessibleMode: this.accessibleMode,
          itemId: this.itemId
        }
      }
    };
    this.navController.navigateBack(constants.PAGE.ADDRESS, navigationExtras);
  }

}
